import { useNavigate } from 'react-router';
import { Modal, ModalHeader } from '#components/patterns/modal/index.ts';
import { useAuth } from '#global/context/auth/useAuth.tsx';
import { page, Titled } from '#util/title.ts';
import { RenameOrgForm } from './RenameOrgForm.tsx';

/**
 * {@link RenameOrgModal} shows a form for renaming the current organization.
 */
export function RenameOrgModal() {
  const { user } = useAuth();
  const navigate = useNavigate();

  function returnToUserSettings() {
    void navigate('..', { replace: true });
  }

  if (!user) {
    return null;
  }

  return (
    <Modal isOpen={true} onClose={returnToUserSettings}>
      <Titled title={() => page('Rename organization')}>
        <ModalHeader>Rename organization</ModalHeader>
        <RenameOrgForm
          orgId={user.organizationID}
          defaultValues={{ name: user.organization.name }}
          onSuccess={returnToUserSettings}
          onCancel={returnToUserSettings}
        />
      </Titled>
    </Modal>
  );
}
